"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { SegmentedControl } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

type AuthModeSwitchProps = {
  currentMode: "sign-in" | "sign-up";
};

const AuthModeSwitch = ({ currentMode }: AuthModeSwitchProps) => {
  const router = useRouter();
  const t = useTranslations("auth.modeSwitch");

  const handleValueChange = (value: string) => {
    if (value === currentMode) {
      return;
    }

    router.push(value === "sign-up" ? "/sign-up" : "/sign-in");
  };

  return (
    <SegmentedControl.Root
      className={S.authModeSwitch}
      size="3"
      radius="full"
      value={currentMode}
      onValueChange={handleValueChange}
    >
      <SegmentedControl.Item value="sign-in">{t("signIn")}</SegmentedControl.Item>
      <SegmentedControl.Item value="sign-up">{t("signUp")}</SegmentedControl.Item>
    </SegmentedControl.Root>
  );
};

export default AuthModeSwitch;
